/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GENERATE_SUMMARY_DATA, GENERATE_SUMMARY_DATA_RECEIVED ,REQUEST_AI_LOGS,AI_LOGS_RECEIVED} = constants.generateSummaryConstants;

export default {
    REQUEST_GENERATE_SUMMARY_DATA,
    GENERATE_SUMMARY_DATA_RECEIVED,
    REQUEST_AI_LOGS,
    AI_LOGS_RECEIVED,

  requestGenerateSummary: payload => ({
    type: REQUEST_GENERATE_SUMMARY_DATA,
    payload
  }),
  GenerateSummaryReceived: () => ({
    type: GENERATE_SUMMARY_DATA_RECEIVED
  }),
  requestAILogs:() =>({
    type: REQUEST_AI_LOGS,
    payload
  }),
  AILogsReceived:() =>({
    type: AI_LOGS_RECEIVED

  })
};
